<template>
  <div class="toTop">
    <span class="toTop"></span>
  </div>
</template>

<script>
export default {
  name: 'toTop',
  data () {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// top.vue?453605b4